import { Link } from 'react-router-dom';
import { useReveal } from '../../hooks/useReveal';

export default function Footer() {
  const { isVisible, ref } = useReveal(0.1);

  const services = [
    { name: "Branding & Visual Identity", path: "/services/branding" },
    { name: "Data Driven Growth Marketing", path: "/services/marketing" },
    { name: "AI & Agentic Solutions", path: "/services/ai" },
    { name: "3D Multi Colour Development & Printing", path: "/services/threed" },
    { name: "Web3 & Innovation Consultation", path: "/services/web3" }
  ];

  const quickLinks = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Insights & News", path: "/news" },
    { name: "Expert Articles", path: "/articles" },
    { name: "Careers", path: "/careers" },
    { name: "Contact", path: "/contact" }
  ];

  const socialLinks = [
    { icon: "ri-facebook-fill", href: "https://www.facebook.com/p/Hashadz-Creative-Consultants-61554390672985/", color: "hover:text-blue-400" },
    { icon: "ri-twitter-x-fill", href: "https://twitter.com/hashadz", color: "hover:text-white" },
    { icon: "ri-instagram-line", href: "https://www.instagram.com/hash_life__", color: "hover:text-pink-400" },
    { icon: "ri-linkedin-fill", href: "https://www.linkedin.com/company/hash-adz/", color: "hover:text-blue-500" },
    { icon: "ri-youtube-fill", href: "https://www.youtube.com/c/Hashadz", color: "hover:text-red-500" }
  ];

  return (
    <footer 
      ref={ref as any}
      className="bg-black border-t border-gray-800 relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className={`py-12 md:py-16 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            <div className="lg:col-span-1">
              <Link to="/" className="inline-block mb-6">
                <h3 className="text-3xl font-bold">
                  <span style={{ fontFamily: 'Pacifico, serif' }} className="bg-gradient-to-r from-orange-400 to-red-500 bg-clip-text text-transparent">
                    Hash Adz
                  </span>
                </h3>
              </Link>
              <p className="text-gray-400 text-sm leading-relaxed mb-6">
                A digital consultancy born in Kochi, Kerala. Empowering businesses to lead in the digital realm through innovation, AI, and strategic design.
              </p>
              <div className="flex gap-4">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 ${social.color} transition-all duration-300 hover:scale-110`}
                  >
                    <i className={`${social.icon} text-lg`}></i>
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-white font-bold mb-6">Our Services</h4>
              <ul className="space-y-3">
                {services.map((service, index) => (
                  <li key={index}>
                    <Link 
                      to={service.path} 
                      className="text-gray-400 hover:text-orange-400 text-sm transition-colors flex items-center gap-2 group"
                    >
                      <i className="ri-arrow-right-s-line text-orange-500/50 group-hover:translate-x-1 transition-transform"></i>
                      {service.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-6">Quick Links</h4>
              <ul className="space-y-3">
                {quickLinks.map((link, index) => (
                  <li key={index}>
                    <Link 
                      to={link.path} 
                      className="text-gray-400 hover:text-orange-400 text-sm transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-6">Get in Touch</h4>
              <div className="space-y-4 text-sm text-gray-400">
                <div className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-orange-500 mt-1"></i>
                  <span>Hash Creative Consultants,<br />Adan's Plaza, Link Rd, Stadium Rd,<br />behind JLN, Janatha, Kathrikadavu,<br />Palarivattom, Kochi, Kerala 682025</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-mail-line text-orange-500"></i>
                  <a href="mailto:hello@hashadz.com" className="hover:text-white transition-colors">hello@hashadz.com</a>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-phone-line text-orange-500"></i>
                  <a href="tel:+919995612933" className="hover:text-white transition-colors">+91 999 56 129 33</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500">
            <p>&copy; {new Date().getFullYear()} Hash Adz Creative Consultants. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}